import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";
import { BRAND_COLORS } from "../lib/bookingStatus";

/**
 * Feb 2026 · Landing nach Klick auf "Löschung rückgängig machen"
 * (5 Sep 2026 · User-Directive). Backend redirect't hierher mit
 * ?status=success oder ?status=invalid.
 */
export default function DeletionRevoke() {
  const [params] = useSearchParams();
  const status = params.get("status");
  const ok = status === "success";
  return (
    <div
      className="min-h-screen flex items-center justify-center p-8"
      style={{ background: BRAND_COLORS.ivory }}
      data-testid="deletion-revoke-page"
    >
      <div className="max-w-md w-full bg-white border border-navy/10 p-10 text-center">
        {ok ? (
          <>
            <CheckCircle
              className="w-14 h-14 mx-auto mb-6"
              strokeWidth={1.4}
              style={{ color: BRAND_COLORS.greenDeep }}
              data-testid="deletion-revoke-icon-success"
            />
            <div className="label-caps mb-3">Weissblom</div>
            <h1 className="font-display text-3xl md:text-4xl text-navy mb-4">
              Löschung gestoppt
            </h1>
            <p className="text-[14px] text-navy-dark/80 leading-relaxed mb-8">
              Ihr Konto bleibt bestehen. Sie können Weissblom wie gewohnt
              weiternutzen. Falls Sie das Konto später doch löschen möchten,
              starten Sie den Vorgang jederzeit erneut in den Einstellungen.
            </p>
          </>
        ) : (
          <>
            <XCircle
              className="w-14 h-14 mx-auto mb-6 text-navy-dark/40"
              strokeWidth={1.4}
              data-testid="deletion-revoke-icon-invalid"
            />
            <div className="label-caps mb-3">Weissblom</div>
            <h1 className="font-display text-3xl md:text-4xl text-navy mb-4">
              Link nicht mehr gültig
            </h1>
            <p className="text-[14px] text-navy-dark/80 leading-relaxed mb-8">
              Dieser Widerrufs-Link ist entweder bereits verwendet oder das
              Konto wurde in der Zwischenzeit bereits gelöscht. Für
              Rückfragen wenden Sie sich bitte an unser Team.
            </p>
          </>
        )}
        <Link
          to="/login"
          data-testid="deletion-revoke-login-link"
          className="inline-block bg-navy text-ivory px-6 py-3 text-[12px] tracking-[0.15em] uppercase hover:bg-navy-dark transition-colors"
          style={{ background: BRAND_COLORS.navy }}
        >
          Zur Anmeldung
        </Link>
      </div>
    </div>
  );
}
